import { render, staticRenderFns } from "./TopChosen.vue?vue&type=template&id=f307d536&scoped=true"
import script from "./TopChosen.vue?vue&type=script&lang=js"
export * from "./TopChosen.vue?vue&type=script&lang=js"
import style0 from "./TopChosen.vue?vue&type=style&index=0&id=f307d536&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f307d536",
  null
  
)

export default component.exports